import React from 'react'
import {motion} from 'framer-motion'
import { useStore } from '../../../../../lib/context'

const NavModuleSearchCloseButton = () => {
    const {articleQueryStore:{updateIsSearching} } = useStore();
    return (
        <motion.div
            className='flex--center nav--search-close'
            initial={{ opacity: 0, y: 3}}
            animate={{ opacity: 1, y: 0}}
            exit={{ opacity: 0, y: -1}}
            transition={{delay: .1}}
        >
            {/* <svg onClick={() => updateIsSearching(false)} width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="30" cy="30" r="30" fill="white"/>
                <path d="M17 17L43.5 43.5" stroke="black" stroke-width="2" stroke-linecap="round"/>
                <path d="M44 17L17.5 43.5" stroke="black" stroke-width="2" stroke-linecap="round"/>
            </svg> */}

            <svg onClick={() => updateIsSearching(false)} width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle opacity="0.7" cx="21.1008" cy="21.1008" r="21.1008" transform="rotate(90 21.1008 21.1008)" fill="white"/>
                <path d="M14.5 14.5L28.5 28.5" stroke="#606060" strokeWidth="2"/>
                <path d="M28.5 14.5L14.5 28.5" stroke="#606060" strokeWidth="2"/>
            </svg>


            <style jsx>{`
                svg {
                    height: 32px;
                    cursor: pointer;
                    transition: .15s ease-in-out;
                }

                svg:hover  {
                    transform: scale(.92);
                    transform-origin: center center;
                }

                circle {
                    transition: opacity .15s ease;
                }

                svg:hover circle{
                    opacity: 1;
                }

                :global(.nav--search-close) {
                    padding: 24px 0 12px;
                }
            `}</style>
        </motion.div>
    )
}

export default NavModuleSearchCloseButton   